/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Current_LineInputs */

const en_live_caption_current_line = /** @type {(inputs: Live_Caption_Current_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current line`)
};

const fr_live_caption_current_line = /** @type {(inputs: Live_Caption_Current_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligne actuelle`)
};

const de_live_caption_current_line = /** @type {(inputs: Live_Caption_Current_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Linie`)
};

const it_live_caption_current_line = /** @type {(inputs: Live_Caption_Current_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linea corrente`)
};

const ru_live_caption_current_line = /** @type {(inputs: Live_Caption_Current_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущая линия`)
};

const es_live_caption_current_line = /** @type {(inputs: Live_Caption_Current_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Línea actual`)
};

const zh_cn2_live_caption_current_line = /** @type {(inputs: Live_Caption_Current_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前线路`)
};

const ja_live_caption_current_line = /** @type {(inputs: Live_Caption_Current_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のライン`)
};

const hi_live_caption_current_line = /** @type {(inputs: Live_Caption_Current_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान रेखा`)
};

const pt_pt2_live_caption_current_line = /** @type {(inputs: Live_Caption_Current_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linha atual`)
};

/**
* | output |
* | --- |
* | "Current line" |
*
* @param {Live_Caption_Current_LineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_current_line = /** @type {((inputs?: Live_Caption_Current_LineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Current_LineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_current_line(inputs)
	if (locale === "de") return de_live_caption_current_line(inputs)
	if (locale === "it") return it_live_caption_current_line(inputs)
	if (locale === "ru") return ru_live_caption_current_line(inputs)
	if (locale === "es") return es_live_caption_current_line(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_current_line(inputs)
	if (locale === "ja") return ja_live_caption_current_line(inputs)
	if (locale === "hi") return hi_live_caption_current_line(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_current_line(inputs)
	return en_live_caption_current_line(inputs)
});